<template>
  <div :class="{ '!w-full': attrs.full_width }" v-if="isShow">
    <CollapsibleSection :header-label="$t('relatedRequests')" body-class="w-full flex flex-wrap">
      <DataTableSkeleton v-if="isLoading"></DataTableSkeleton>
      <DataTableVue
        v-else-if="dataSet.length > 0"
        :default-headers="[
          'RequestNumber',
          'OwnerName',
          'CreationDate',
          'DraftStatus',
          'isParentRequest',
          'operation'
        ]"
        :data-set="dataSet"
      >
        <template #headerCell="{ label }">
          <div v-if="label == 'refDraftId'"></div>
        </template>
        <template #cell="{ columnName, columnValue, rowIndex }">
          <div v-if="columnName == 'refDraftId'" class="w-full h-full flex flex-col gap-1">
            <div v-if="dataSet[rowIndex].RequestNumber == currentRequest">
              <i class="fa fa-check text-primary"></i>
            </div>
          </div>
          <div v-if="columnName == 'name'" class="w-full h-full flex flex-col gap-1">
            <div>{{ columnValue[0] }}</div>
            <div>{{ columnValue[1] }}</div>
          </div>
          <div
            v-if="columnName == 'RequestNumber'"
            class="w-full h-full flex flex-col gap-1 items-center"
          >
            <div>{{ columnValue }}</div>

            <div
              v-if="!dataSet[rowIndex].refDraftId"
              class="rounded bg-primary flex justify-center text-white p-1"
            >
              {{ $t('parentRequest') }}
            </div>
          </div>
        </template>
      </DataTableVue>
      <div v-else class="w-full p-2 bg-brand-gray-250 text-center">
        {{ $t('noDataFound') }}
      </div>
    </CollapsibleSection>
  </div>
</template>

<script setup>
import CollapsibleSection from '@/components/Ui/CollapsibleSection.vue'
import DataTableVue from '@/components/DataTable/index.vue'
import DataTableSkeleton from '@/components/skeletons/DatatableSkeleton.vue'
import { useFormStore } from '@/stores/form'
import clientLookups from '@/assets/json/clientLookups.json'
import { onMounted, ref, useAttrs } from 'vue'
import apiHelperService from '@/services'
import { useRoute } from 'vue-router'
import { DateTime } from 'luxon'

const attrs = useAttrs()
const isLoading = ref(true)

const dataSet = ref([])
const formStore = useFormStore()
const route = useRoute()
const isShow = ref(false)
const currentRequest = ref()

const getRelatedDrafts = async () => {
  const { requestNumber } = formStore.draft
  const { ServiceTransactions } = clientLookups
  currentRequest.value = requestNumber || route.query.requestNumber

  const response = await apiHelperService.get(
    `/api/requestmaster/${currentRequest.value}/relatedRequests`
  )
  dataSet.value = response
    ?.filter((e) => e.serviceTransactionId != ServiceTransactions.newBornPackage)
    ?.map((draft) => {
      isShow.value = draft.refDraftId ? true : false
      return {
        RequestNumber: draft.requestNumber,
        CreationDate: DateTime.fromJSDate(new Date(draft.creationDate)).toFormat(
          'dd/MM/yyyy hh:mm:ss a'
        ),
        ServiceType: draft.serviceTransactionName,
        name: [draft.request.arabicName, draft.request.englishName],
        refDraftId: draft.refDraftId
      }
    })
}

onMounted(async () => {
  await getRelatedDrafts()

  isLoading.value = false
})
</script>

<script>
export default {
  name: 'DataTableForm'
}
</script>
<style lang="scss" scoped></style>
